// extracted by css-extract-rspack-plugin
export default {"page":"ScholarshipV2-module__page"};